import React, { useState } from 'react';
import '../styles/styles.css';

const FlashcardOptionsModal = ({ visible, onConfirm, onCancel }) => {
    const [maxFlashcards, setMaxFlashcards] = useState('10');
    const [difficulty, setDifficulty] = useState('easy');
    const [error, setError] = useState('');

    const handleConfirm = () => {
        const num = parseInt(maxFlashcards, 10);
        if (isNaN(num) || num < 1 || num > 50) {
            setError('Please enter a number between 1 and 50.');
            return; // Do not resolve, let user correct input
        }
        setError('');
        try {
            console.log('[FlashcardOptionsModal] Calling onConfirm with:', { maxFlashcards: num, enableOcr: true, difficulty });
            console.log('[FlashcardOptionsModal] Selected difficulty:', difficulty);
            onConfirm({ maxFlashcards: num, enableOcr: true, difficulty });
        } catch (error) {
            console.error('[FlashcardOptionsModal] Error in onConfirm:', error);
            setError('An error occurred. Please try again.');
        }
    };


    if (!visible) return null;

    return (
        <div className="modal-overlay" style={{ pointerEvents: 'auto' }}>
            <div className="modal-container quiz-options-modal">
                <h2 className="modal-title">Select Flashcard Options</h2>
                <div className="input-container">
                    <label className="modal-label">Maximum Number of Flashcards</label>
                    <input
                        className="text-input"
                        type="number"
                        value={maxFlashcards}
                        onChange={(e) => {
                            setMaxFlashcards(e.target.value);
                            setError('');
                        }}
                        placeholder="Enter 1-50"
                        min="1"
                        max="50"
                    />
                </div>
                <div className="input-container">
                    <label className="modal-label">Difficulty Level</label>
                    <select
                        className="select-input"
                        value={difficulty}
                        onChange={(e) => setDifficulty(e.target.value)}
                    >
                        <option value="easy">Easy</option>
                        <option value="medium">Medium</option>
                        <option value="hard">Hard</option>
                    </select>
                </div>
                {error && <p className="error-text">{error}</p>}
                <div className="modal-footer">
                    <button type="button" className="button confirm-button" onClick={handleConfirm}>Confirm</button>
                    <button type="button" className="button button--ghost" onClick={() => {
                        console.log('[FlashcardOptionsModal] handleCancel called');
                        onCancel();
                    }}>Cancel</button>
                </div>
            </div>
        </div>
    );
};

export default FlashcardOptionsModal;


